import { Injectable } from '@angular/core';
import { PartnerService } from './partner.service';

@Injectable({ providedIn: 'root' })
export class PartnerResolver {
  constructor(private partnerService: PartnerService) {}

  resolve() {
    return this.partnerService.fetchPartners();
  }
}
